import { useEffect, useState } from 'react';
import Spinner from './Spinner';

const STAGES = [
  'Подготавливаем реквизиты…',
  'Ищем доступный банк…',
  'Формируем платёж…',
  'Проверяем доступность…',
];

const STAGE_INTERVAL_MS = 2500;

const RequisiteWaitSpinner = () => {
  const [stage, setStage] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setStage((prev) => (prev + 1) % STAGES.length);
    }, STAGE_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);

  return <Spinner description={STAGES[stage]} />;
};

export default RequisiteWaitSpinner;
